import { useState, useEffect } from 'react';
import { AnimatePresence } from 'motion/react';
import { getStoredNickname, setStoredNickname } from '../gamePrefs';
import { characterProfile, characterProfilesDemo, player, UI_DEMO, UI_DEMO_LABELS } from '../fixtures/uiKitFixtures';
import GamePreviewShell from './GamePreviewShell';
import GameTopBar from './GameTopBar';
import GameChatPanel from './GameChatPanel';
import GameDialogueBar from './GameDialogueBar';
import GameChoiceButtons from './GameChoiceButtons';
import GameNotificationsPreview from './GameNotificationsPreview';
import GameNicknameModal from './GameNicknameModal';
import GameSettingsModal from './GameSettingsModal';
import {
  GameAlbumPurchaseModal,
  GameAlbumRewardModal,
  GameCharacterAlbumsModal,
  GameCharacterWindow,
  GameGiftsModal,
  GameItemShopModal,
  GameRelationshipUpModal,
  GameTokenPurchaseModal
} from './GameModals';

function titleFor(demo) {
  const found = UI_DEMO_LABELS.find((x) => x.id === demo);
  return found ? found.label : 'Preview';
}

export default function GameUiKitOverlay({ demo, onClose }) {
  const [settingsSubview, setSettingsSubview] = useState(null);

  useEffect(() => {
    setSettingsSubview(null);
  }, [demo]);

  const wide =
    demo === UI_DEMO.CHAT ||
    demo === UI_DEMO.CHARACTER ||
    demo === UI_DEMO.CHARACTER_ALBUMS ||
    demo === UI_DEMO.ALBUM_SHOP ||
    demo === UI_DEMO.ITEM_SHOP ||
    demo === UI_DEMO.TOKEN_SHOP;
  const containBody = demo === UI_DEMO.CHAT || demo === UI_DEMO.CHARACTER;
  const leaveTopBarGap = demo === UI_DEMO.CHARACTER;

  const shellTitle =
    demo === UI_DEMO.SETTINGS && settingsSubview === 'nickname'
      ? 'Nickname'
      : titleFor(demo);

  return (
    <AnimatePresence>
      {demo ? (
        <GamePreviewShell
          key={demo}
          title={shellTitle}
          onClose={onClose}
          wide={wide}
          containBody={containBody}
          leaveTopBarGap={leaveTopBarGap}
        >
          {demo === UI_DEMO.TOP_BAR && (
            <div className="bg-game-page p-0">
              <GameTopBar nickname={getStoredNickname(player.nickname)} tokens={player.tokens} />
              <div className="h-32 bg-game-page/40" aria-hidden />
            </div>
          )}
          {demo === UI_DEMO.CHAT && (
            <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col p-3">
              <GameChatPanel />
            </div>
          )}
          {demo === UI_DEMO.ALBUM_SHOP && <GameAlbumPurchaseModal />}
          {demo === UI_DEMO.TOKEN_SHOP && <GameTokenPurchaseModal />}
          {demo === UI_DEMO.CHARACTER && <GameCharacterWindow profiles={characterProfilesDemo} />}
          {demo === UI_DEMO.TOASTS && <GameNotificationsPreview />}
          {demo === UI_DEMO.RELATIONSHIP_UP && <GameRelationshipUpModal />}
          {demo === UI_DEMO.ALBUM_REWARD && <GameAlbumRewardModal />}
          {demo === UI_DEMO.CHARACTER_ALBUMS && <GameCharacterAlbumsModal />}
          {demo === UI_DEMO.GIFTS && <GameGiftsModal />}
          {demo === UI_DEMO.ITEM_SHOP && <GameItemShopModal characterName={characterProfile.name} />}
          {demo === UI_DEMO.DIALOGUE && (
            <div className="flex min-h-[280px] flex-col justify-end bg-game-page">
              <GameDialogueBar />
            </div>
          )}
          {demo === UI_DEMO.CHOICES && (
            <div className="flex min-h-[320px] flex-col items-center justify-center bg-game-page py-6">
              <GameChoiceButtons />
            </div>
          )}
          {demo === UI_DEMO.SETTINGS && settingsSubview !== 'nickname' && (
            <GameSettingsModal onOpenNickname={() => setSettingsSubview('nickname')} />
          )}
          {demo === UI_DEMO.SETTINGS && settingsSubview === 'nickname' && (
            <GameNicknameModal
              initialNickname={getStoredNickname(player.nickname)}
              onSave={(name) => {
                setStoredNickname(name);
                setSettingsSubview(null);
              }}
              onBack={() => setSettingsSubview(null)}
            />
          )}
          {demo === UI_DEMO.NICKNAME && (
            <GameNicknameModal
              initialNickname={getStoredNickname(player.nickname)}
              onSave={(name) => setStoredNickname(name)}
            />
          )}
        </GamePreviewShell>
      ) : null}
    </AnimatePresence>
  );
}
